import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AppUser, MeResponse } from '@contracts/auth';
import { api } from '../lib/api';

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => api.get<MeResponse>('/api/v1/auth/me'),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}

/** Whether the app may be used: login is off (local dev) or the signed-in user is approved. */
export function canUseApp(me: MeResponse | undefined): boolean {
  if (!me) return false;
  return !me.authRequired || me.user?.status === 'approved';
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<{ loggedOut: boolean }>('/api/v1/auth/logout'),
    onSuccess: () => {
      qc.clear();
      window.location.assign('/login');
    },
  });
}

export function useMyPreferences() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (prefs: { notifyAlerts?: boolean; notifyOutcomes?: boolean; notifyLine?: boolean }) =>
      api.post<{ user: AppUser }>('/api/v1/auth/me/preferences', prefs),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['me'] }),
  });
}
